import { render } from "./tw-ws-number.vue?vue&type=template&id=c15b9ea8"
import script from "./tw-ws-number.vue?vue&type=script&lang=js"
export * from "./tw-ws-number.vue?vue&type=script&lang=js"
script.render = render

export default script